import { render } from "./FormularioAnimal.vue?vue&type=template&id=364e2c16&scoped=true"
import script from "./FormularioAnimal.vue?vue&type=script&lang=js"
export * from "./FormularioAnimal.vue?vue&type=script&lang=js"

import "./FormularioAnimal.vue?vue&type=style&index=0&id=364e2c16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364e2c16"]])

export default __exports__